import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Benefits = ({ benefits }) => {
  return (
    <section className="section-padding container-padding bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Why This Program is <span className="gradient-text-green-purple">Different</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Not just a certification—a complete career transformation system
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = LucideIcons[benefit.icon] || LucideIcons.Star;
            const colorClass = index % 3 === 0 ? 'icon-green' : index % 3 === 1 ? 'icon-purple' : 'icon-green';
            
            return (
              <Card
                key={index}
                className={`card-hover border-2 animate-fade-in-up stagger-${(index % 6) + 1}`}
              >
                <CardContent className="p-6">
                  <div className={`${colorClass} w-14 h-14 rounded-xl flex items-center justify-center mb-4`}>
                    <IconComponent className="w-7 h-7" />
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-gray-900">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
